import React from 'react';

import { TextField } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTooltip } from 'styles/common';

import { getColorFromKey } from 'constants/helper';

const HeaderPrimaryTextComponent = ({ value, handleChange, ...props }) => (
  <StyledTooltip title={value}>
    <StyledTextField
      {...props}
      variant="outlined"
      value={value}
      onChange={handleChange}
      placeholder="Enter Template Name"
    />
  </StyledTooltip>
);

export default HeaderPrimaryTextComponent;

const StyledTextField = styled(TextField)`
  height: 5ch;
  min-width: 35ch;
  width: auto;
  .MuiInputBase-root {
    font-size: 20px;
    .MuiInputBase-input {
      padding: 10px;
    }
    .MuiOutlinedInput-notchedOutline {
      border-color: ${getColorFromKey('lightGrey')};
    }
  }
`;
